module.exports = __webpack_public_path__ + "bb6c5b368b51d302803ef1ed08bd7192.svg";